module.exports = __webpack_public_path__ + "static/media/pool2.67bfd7c0.jpg";